import { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  TextField,
  Typography,
} from "@material-ui/core";
import ButtonWithLoading from "components/ButtonWithLoading";
import CloseIcon from "@material-ui/icons/Close";

interface Props {
  isOpen: boolean;
  isSaving: boolean;
  onClose: () => void;
  onSubmit: (minutes: number) => void;
}

export function SecretTransitionModal(props: Props) {
  const { t } = useTranslation("gateway");
  const { isOpen, onClose } = props;
  const [transitionAmount, setTransitionAmount] = useState(0);
  const isValidAmount = transitionAmount <= 60;
  const helperText = isValidAmount
    ? t("gatewaySecret.transitionModal.validAmount", {
        amount: transitionAmount,
      })
    : t("gatewaySecret.transitionModal.invalidAmount");

  return (
    <Dialog open={isOpen} onClose={onClose} maxWidth="sm" fullWidth>
      <IconButton
        size="small"
        onClick={onClose}
        style={{
          position: "absolute",
          top: "0.7rem",
          right: "0.7rem",
        }}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
      <DialogTitle style={{ paddingBottom: 0 }}>
        {t("gatewaySecret.transitionModal.title")}
      </DialogTitle>
      <Typography
        variant="caption"
        color="textSecondary"
        style={{ marginBottom: 16, padding: "5px 24px" }}
      >
        {t("gatewaySecret.transitionModal.subtitle")}
      </Typography>

      <DialogContent>
        <TextField
          variant="outlined"
          fullWidth
          type="number"
          label={t("gatewaySecret.transitionModal.amountLabel")}
          helperText={helperText}
          inputProps={{ min: 0, max: 60 }}
          value={transitionAmount}
          onChange={e => {
            const { value } = e.target;
            setTransitionAmount(Number(value));
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button size="small" onClick={onClose}>
          {t("common:cancel")}
        </Button>
        <ButtonWithLoading
          loading={props.isSaving}
          disableElevation
          variant="contained"
          color="primary"
          size="small"
          onClick={() => props.onSubmit(transitionAmount)}
          disabled={!isValidAmount}
        >
          {t("gatewaySecret.actions.generateNew")}
        </ButtonWithLoading>
      </DialogActions>
    </Dialog>
  );
}
